import { REGIONS_BY_ID, type RegionId } from '@snootsvet/shared'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/frontend/components/ui/select'
import { useViewerRegion } from '@/frontend/features/region/region-context'

/**
 * Header dropdown for switching the active region. Renders nothing for
 * single-region staff, and offers only the regions the staff member is assigned
 * to. Styled as a borderless, flag-prefixed control beside the clinic chip.
 */
export function RegionSwitcher() {
  const { region, setRegion, regions } = useViewerRegion()

  // Single-region staff have nothing to switch between.
  if (regions.length <= 1) return null

  // Trigger labels — Base UI resolves the selected label from this list.
  const items = regions.map((id) => ({
    label: `${REGIONS_BY_ID[id].flag} ${id.toUpperCase()}`,
    value: id,
  }))

  return (
    <Select
      items={items}
      value={region}
      onValueChange={(value) => {
        if (value) setRegion(value as RegionId)
      }}
    >
      <SelectTrigger
        aria-label="Active region"
        className="h-8 gap-1.5 rounded-md border-0 bg-transparent px-1.5 text-sm text-muted-foreground shadow-none hover:bg-accent hover:text-foreground focus-visible:ring-0"
      >
        <SelectValue />
      </SelectTrigger>
      {/* Size to content, not the compact trigger. */}
      <SelectContent align="end" className="w-auto">
        {regions.map((id) => (
          <SelectItem key={id} value={id} className="pr-12 pl-3 py-2">
            <span>{REGIONS_BY_ID[id].flag}</span>
            <span>{REGIONS_BY_ID[id].name}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
